module.exports = __webpack_public_path__ + "static/media/Map.2a4d73a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Map.jpg
// module id = 91
// module chunks = 0